import nlcInfoStore from "../store/nlcInfo";


const useNlcInfo = (playerId) => {
    const nlcs = nlcInfoStore((state) => state.nlcs);
    const setNlc = nlcInfoStore((state) => state.setNlc);

    // Trả về thông tin của player đó và các hàm cập nhật
    return {
        nlc: nlcs[playerId] ?? 0,
        nlcs,
        setNlc
    };
};

export default useNlcInfo;
